export default __webpack_public_path__ + "static/media/girl_money_boy-min.a1dbf8af.png";